import { FormatMessageType } from '@hooks/useValidation';
import { MIN_FIELD, REQUIRED } from '@utils/validation/validation.constant';
import Yup from '@utils/validation/yup-extended';

import { AeroscopeSensorConfiguration, SensorTypeEnum } from '@/types/sensor/sensors';

import {
  alertTimeoutThresholdSchemaValidation,
  commonSensorConfigurationSchemaValidation,
  hostSchemaValidation,
  portSchemaValidation,
} from './common.schema';

export function aeroscopeSchemaValidation(
  formatMessage: FormatMessageType,
): Yup.ObjectSchema<Partial<AeroscopeSensorConfiguration>> {
  return commonSensorConfigurationSchemaValidation(formatMessage)
    .concat(alertTimeoutThresholdSchemaValidation(formatMessage))
    .shape({
      type: Yup.mixed<SensorTypeEnum>()
        .oneOf([SensorTypeEnum.AEROSCOPE], formatMessage({ id: REQUIRED }))
        .required(formatMessage({ id: REQUIRED })),
      host: hostSchemaValidation(formatMessage),
      port: portSchemaValidation(formatMessage),
      controlUrl: Yup.string().required(formatMessage({ id: REQUIRED })),
      username: Yup.string().required(formatMessage({ id: REQUIRED })),
      password: Yup.string().required(formatMessage({ id: REQUIRED })),
      timeZone: Yup.string().required(formatMessage({ id: REQUIRED })),
      tokenRefresh: Yup.number()
        .required(formatMessage({ id: REQUIRED }))
        .min(0, formatMessage({ id: MIN_FIELD })),
      dataRefresh: Yup.number()
        .required(formatMessage({ id: REQUIRED }))
        .min(0, formatMessage({ id: MIN_FIELD })),
    }) as Yup.ObjectSchema<Partial<AeroscopeSensorConfiguration>>;
}
